module.exports = __webpack_public_path__ + "img/waterSYJ.ce66cc8d.png";